import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/stores/:storeId/products/bulk-create`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const bulkCreate = {
  post: apiPathFunc(pathBase),
};
